import { Map } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    isLoading: true,
})

export default (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.SET_LOADER: {
            return state.merge({
                isLoading: payload,
            })
        }

        default:
            return state
    }
}
